import { CustomError } from 'ts-custom-error';

export class HttpRequestError extends CustomError {
    constructor(public status: number, public message: string) {
        super();
    }
}
